import { Box, Link, Typography } from '@mui/material';
import { isNumber } from 'lodash';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { tournamentActivitySelector } from 'modules/tournament-activity/store/selectors';
import { useStyles } from '../../styles/TournamentGameActivity.styles';

interface WaitingNextGameProps {
  onTournamentClick: () => void;
}

export const WaitingNextGame: FC<WaitingNextGameProps> = ({ onTournamentClick }) => {
  const { classes } = useStyles();

  const name = useSelector(tournamentActivitySelector.name);
  const tournamentActivity = useSelector(tournamentActivitySelector.activity);

  const description = useMemo(() => {
    const id = Number(tournamentActivity.matchGame?.match);
    if (!isNumber(id)) {
      return 'You are on break, waiting for the opponent...';
    }

    return `You are on break in match #${id + 1}: waiting for the opponent...`;
  }, [tournamentActivity.matchGame?.match]);

  if (!tournamentActivity) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        <Typography className={classes.lineClampText}>
          <Link onClick={onTournamentClick}>{name}</Link>
          <Typography component="span" pr={0.5} pl={0.5}>
            -
          </Typography>
          <Typography component="span">{description}</Typography>
        </Typography>
      </Box>
    </Box>
  );
};
